
import Vue from 'vue';
import type { PropOptions, VNode } from 'vue';
import BravadoLogoIcon from './images/bravado-logo.vue.svg';
import type { IPostTopic } from '@/types/community';
const OFFICIAL_SLUG = 'official';

type TopicSizes = 'small' | 'medium';

export default Vue.extend({
  name: 'WarRoomTopic',
  components: {
    BravadoLogoIcon,
  },
  props: {
    isElevated: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    isLink: {
      type: Boolean,
      default: true,
    } as PropOptions<boolean>,
    isActive: {
      type: Boolean,
      default: false,
    } as PropOptions<boolean>,
    topic: {
      type: Object,
      required: true,
    } as PropOptions<IPostTopic>,
    size: {
      type: String,
      default: 'small',
    } as PropOptions<TopicSizes>,
  },
  computed: {
    isOfficial(): boolean {
      return this.topic.slug === OFFICIAL_SLUG;
    },
    rootClass(): Record<string, boolean> {
      return {
        'war-room-topic': true,
        [`war-room-topic--${this.size}`]: true,
        'war-room-topic--elevated': this.isElevated,
        'war-room-topic--active': this.isActive,
      };
    },
  },
  render(h): VNode {
    const rootElement = this.isLink ? 'NuxtLink' : 'span';
    const rootProps = { ...this.$attrs };
    const rootChildren: VNode[] = [];

    if (this.isLink) {
      Object.assign(rootProps, {
        to: { name: 'war-room-topics-topicSlug-posts', params: { topicSlug: this.topic.slug } },
      });
    }

    if (this.isOfficial) {
      rootChildren.push(h(BravadoLogoIcon, { class: 'war-room-topic__icon' }));
    }

    rootChildren.push(h('div', { class: 'war-room-topic__name' }, `${this.topic.emoji} ${this.topic.name}`));

    const rootData = {
      props: rootProps,
      class: this.rootClass,
    };

    if (!this.isLink) {
      Object.assign(rootData, { on: { ...this.$listeners } });
    }

    return h(rootElement, rootData, rootChildren);
  },
});
